import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";
 
// get SalesOrders
export const getSalesOrders = createAsyncThunk("salesOrders/getlist-salesorders", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/getlist-salesorders`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        console.log({ response })
        return response;
    } catch (error) {
        console.error('Error fetching SalesOrders - ', error);
        throw error;
    }
})


